import React, { ReactNode } from 'react';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { ListItemIcon, ListItemText, MenuItem, SxProps, Theme } from '@mui/material';
import Button from '@mui/material/Button';

import { ReadFile, useHiddenFileSelect } from '@paragon/client-tools';
import { assertExhaustiveSwitch } from '@paragon/utilities';

interface Props {
  displayText: ReactNode;
  sx?: SxProps<Theme>;
  client: 'mobile' | 'desktop';
  disabled?: boolean;

  fileTypes: string;
  uploadFiles: (files: ReadFile[]) => void;
  beforeUploadFiles?: () => void;
}

export default function DefaultFileUploader(props: Props) {
  const { fileTypes, displayText, client, disabled, sx } = props;

  const [renderHiddenSelect, selectFile] = useHiddenFileSelect(fileTypes, true);

  async function uploadFiles(files: ReadFile[]) {
    if (props.beforeUploadFiles) {
      props.beforeUploadFiles();
    }

    props.uploadFiles(files);
  }

  async function click() {
    const chosenFiles = await selectFile();
    await uploadFiles(chosenFiles);
  }

  let uploadButton = null;

  switch (client) {
    case 'desktop':
      uploadButton = (
        <Button variant="outlined" startIcon={<FileUploadIcon />} sx={sx} disabled={disabled} onClick={click}>
          {displayText}
        </Button>
      );
      break;

    case 'mobile':
      uploadButton = (
        <MenuItem disabled={disabled} onClick={click}>
          <ListItemIcon>
            <FileUploadIcon />
          </ListItemIcon>
          <ListItemText> {displayText}</ListItemText>
        </MenuItem>
      );
      break;

    default:
      assertExhaustiveSwitch(client);
  }

  return (
    <>
      {!disabled && renderHiddenSelect()}
      {uploadButton}
    </>
  );
}
